export var HIGHLIGHT_PRE_TAG = '__aa-highlight__';
export var HIGHLIGHT_POST_TAG = '__/aa-highlight__';